import { render, staticRenderFns } from "./w-ctrl-viewer.vue?vue&type=template&id=03a4f6f5&lang=pug&"
import script from "./w-ctrl-viewer.vue?vue&type=script&lang=js&"
export * from "./w-ctrl-viewer.vue?vue&type=script&lang=js&"
import style0 from "./w-ctrl-viewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a4f6f5')) {
      api.createRecord('03a4f6f5', component.options)
    } else {
      api.reload('03a4f6f5', component.options)
    }
    module.hot.accept("./w-ctrl-viewer.vue?vue&type=template&id=03a4f6f5&lang=pug&", function () {
      api.rerender('03a4f6f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-ctrl-viewer.vue"
export default component.exports